import { Locales } from '@griply/types';
import { useCallback } from 'react';
import { useCompleteSignupAndLoginMutation } from 'shared/hooks/queries/use-complete-signup-and-login-mutation';
import { useNavigateAppOpenScreen } from 'shared/hooks/use-navigate-app-open-screen';
import { User } from 'shared/types/user';

export const useCompleteSignupAndLogin = () => {
  const navigateAppOpen = useNavigateAppOpenScreen();
  const { mutateAsync, error, reset, isPending, isSuccess } =
    useCompleteSignupAndLoginMutation();

  const completeSignupAndLogin = useCallback(
    async (
      claimToken: string,
      {
        password,
        name,
        locale,
      }: { password: string; name?: string; locale?: Locales },
    ) => {
      let user: User | null;
      try {
        user = await mutateAsync({ claimToken, password, name, locale });
      } catch {
        // the mutation's `error` state carries the form error; the page has no catch
        return;
      }
      // specifically navigate as a revalidation of this page would mean that the user is logged out again
      navigateAppOpen(user);
    },
    [mutateAsync, navigateAppOpen],
  );

  return {
    completeSignupAndLogin,
    error: error?.kind,
    isLoading: isPending,
    isSuccess,
    reset,
  };
};
